import { Pipe, PipeTransform } from '@angular/core';
import { MemberStatusTypes } from '../models/domain/member';


@Pipe({ name: 'getMemberStatus' })
export class MemberStatusPipe implements PipeTransform {

    transform(value: MemberStatusTypes): string {

        switch ( value ) {
            case 0:
                return 'Active'
            case MemberStatusTypes.Inactive:
                return 'Inactive';
            case MemberStatusTypes.Closed:
                return 'Closed';

            default:
                return 'Active'
        }

    }

}
